// extracted by mini-css-extract-plugin
export default {"courses":"Courses_courses__hjTw8","headText":"Courses_headText__zZIgL","enroll":"Courses_enroll__yzssT","headImg":"Courses_headImg__+k9g1","blogsSec":"Courses_blogsSec__6fXFF"};